import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SuccessOutput } from '@shared/models';
import {
  GroupMenu,
  ManageGroupMenuPayload,
  ModulesItemsTable,
  Role,
  UpdateGroupRolesPayload,
  UserPermissionsResponse,
} from '@shared/models/permissions.model';

export type GroupMenuResponse = Record<string, string[]>;

@Injectable({ providedIn: 'root' })
export class PermissoesService {
  private readonly API = `${environment.baseUrl}/menu`;
  private readonly USERS_API = `${environment.baseUrl}/users`;
  private readonly ROLES_API = `${environment.baseUrl}/roles`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<SuccessOutput<ModulesItemsTable[]>> {
    return this.http.get<SuccessOutput<ModulesItemsTable[]>>(`${this.API}/all`);
  }

  getGroupMenu(keycloakGroupId: string): Observable<GroupMenuResponse> {
    return this.http.get<GroupMenuResponse>(`${this.API}/group-menu/${keycloakGroupId}`);
  }

  manageGroupMenu(keycloakGroupId: string, payload: ManageGroupMenuPayload): Observable<unknown> {
    return this.http.post(`${this.API}/manage-group-menu/${keycloakGroupId}`, payload);
  }

  getCurrentUserPermissions(): Observable<SuccessOutput<UserPermissionsResponse>> {
    return this.http.get<SuccessOutput<UserPermissionsResponse>>(`${this.USERS_API}/me/permissions`);
  }

  getAllRoles(): Observable<SuccessOutput<Role[]>> {
    return this.http.get<SuccessOutput<Role[]>>(`${this.ROLES_API}/all`);
  }

  getGroupRoles(keycloakGroupId: string): Observable<GroupMenu[]> {
    return this.http.get<GroupMenu[]>(`${this.ROLES_API}`, {
      params: { keycloakGroupId },
    });
  }

  updateGroupRoles(payload: UpdateGroupRolesPayload): Observable<unknown> {
    return this.http.put(`${this.ROLES_API}`, payload);
  }
}
